import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TableSortModel } from '../typings/table-sort';

// A table column heading that reports its field when pressed and shows the active sort direction
@Component({
  selector   : 'wor-sort-header',
  styles: [ require('./sort-header.component.scss') ],
  template: require('./sort-header.component.html')
})
export class SortHeaderComponent {
  @Input() field : string;
  @Input() sort  : TableSortModel;

  @Output() sorted : EventEmitter<string> = new EventEmitter<string>();

  isActive () : boolean {
    return !!this.sort && this.sort.field === this.field;
  }

  isSorted ( direction : string ) : boolean {
    return !!this.sort && this.sort.field === this.field && this.sort.direction === direction;
  }
}
